import { type UnitInsightLlmChatsResponse } from '../../../../api/customEndpoints/getUnitInsightLlmChats';
import { Link, useSearchParams } from 'react-router-dom';
import { Button, buttonVariants } from '../../../../components/ui/button';
import { cn } from '../../../../lib/utils';
import { useTranslate } from 'ra-core';

export function ChatSidebar({ chats }: { chats: UnitInsightLlmChatsResponse }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const translate = useTranslate();

  return (
    <div className="space-y-2 py-2">
      <Button
        variant="outline"
        disabled={!searchParams.get('chatId')}
        onClick={() => {
          setSearchParams((params) => {
            params.delete('chatId');
            return params;
          });
        }}
      >
        {translate('moonstar.unitPerformance.chat.newChat')}
      </Button>
      <div className="divide-y">
        {chats.data.map((chat, index) => (
          <Link
            className={cn(
              buttonVariants({
                variant:
                  searchParams.get('chatId') === String(chat.id)
                    ? 'default'
                    : 'ghost',
              }),
              'my-1 flex h-auto w-full flex-col items-stretch justify-start py-2 text-left'
            )}
            to={{ search: `?chatId=${chat.id}` }}
            key={chat.id}
          >
            <span>
              {translate('moonstar.unitPerformance.chat.chatNumber', {
                number: chats.data.length - index,
              })}
            </span>
            <span className="text-xs opacity-80">
              {new Date(chat.createdOn).toLocaleString()}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
}
